import { FilterOperator, LogicalOperator } from "@/shared/Enums";

export class AdvancedFilterCondition {
  propertyName: string = "";
  operator: FilterOperator = FilterOperator.Equal;
  value: any = null;
  values: any[] | null = null;
  logicalOperator: LogicalOperator = LogicalOperator.And;
}

export const CreateEqualAdvancedFilterCondition = (propertyName: string, value: any) => {
  const condition = new AdvancedFilterCondition();
  condition.propertyName = propertyName;
  condition.value = value;
  return condition;
};

export const CreateContainAdvancedFilterCondition = (propertyName: string, values: any[]) => {
  const condition = new AdvancedFilterCondition();
  condition.propertyName = propertyName;
  condition.values = values;
  condition.operator = FilterOperator.In;
  return condition;
};

export const CreateRangeAdvancedFilterCondition = (propertyName: string, fromValue: any, toValue: any) => {
  var filterList: AdvancedFilterCondition[] = [];

  if (fromValue) {
    const conditionFrom = new AdvancedFilterCondition();
    conditionFrom.propertyName = propertyName;
    conditionFrom.value = fromValue;
    conditionFrom.operator = FilterOperator.GreaterThanOrEqual;
    filterList.push(conditionFrom);
  }

  if (toValue) {
    const conditionTo = new AdvancedFilterCondition();
    conditionTo.propertyName = propertyName;
    conditionTo.value = toValue;
    conditionTo.operator = FilterOperator.LessThanOrEqual;
    filterList.push(conditionTo);
  }

  return filterList;
};
